import {
  getMessaging,
  onMessage,
  getToken,
  isSupported,
} from "firebase/messaging";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBltQCpGRqiSmPvKolxgTMylKtpbt0C7xY",
  authDomain: "pushnotification-def9c.firebaseapp.com",
  projectId: "pushnotification-def9c",
  storageBucket: "pushnotification-def9c.firebasestorage.app",
  messagingSenderId: "1050340136348",
  appId: "1:1050340136348:web:d6688286c3985c805de459",
  measurementId: "G-JQJN48VQJ5",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
let tokenGenerationPromise = null;

// 🛑 Detect Safari (Does NOT support Firebase Cloud Messaging)
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

// 🔥 Detect Firefox
const isFirefox = navigator.userAgent.toLowerCase().includes("firefox");

// 🔍 Detect Private Browsing (Firefox & Incognito Mode)
const checkPrivateMode = async () => {
  return new Promise((resolve) => {
    if (isFirefox) {
      const db = indexedDB.open("test");
      db.onerror = () => resolve(true); // Firefox in private mode blocks IndexedDB
      db.onsuccess = () => resolve(false);
    } else {
      resolve(!(window.indexedDB || window.localStorage));
    }
  });
};

export const generateToken = () => {
  // React StrictMode mounts effects twice in development. Share the same
  // request so concurrent getToken calls cannot race to subscribe to push.
  if (!tokenGenerationPromise) {
    tokenGenerationPromise = requestToken().finally(() => {
      tokenGenerationPromise = null;
    });
  }
  return tokenGenerationPromise;
};

const requestToken = async () => {
  try {
    if (!(await isSupported())) {
      console.warn("Firebase Cloud Messaging is not supported in this browser.");
      return null;
    }

    if (isSafari) {
      console.warn("⚠️ Safari does not support Firebase Cloud Messaging.");
      // alert("🚫 Push notifications are not supported in Safari.");
      return null;
    }

    const isPrivate = await checkPrivateMode();
    if (isPrivate) {
      console.warn("⚠️ Private browsing detected. Notifications may not work.");
      // alert("🚫 Push notifications are blocked in private browsing mode.");
      return null;
    }

    const serviceWorkerRegistration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js",
    );

    const permission = await Notification.requestPermission();
    // console.log("Permission:", permission);

    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BPxnM1rwwuHzy3VWo1ohR13tWqiJBa2kmehbqBcT0MiG7XwjYdm8fpSDDd4UXVS7Ie3OMtYZ4jTwGdqS-MgDcDI",
        serviceWorkerRegistration,
      });

      // console.log("Token:", token);
      if (token) {
        try {
          localStorage.setItem("fcm_token", token);
        } catch (storageError) {
          console.warn("⚠️ localStorage unavailable. Token not saved.");
        }
      } else {
        console.warn("Token retrieval failed. Try again later.");
      }
      return token || null;
    } else if (permission === "denied") {
      openPermissionModal();
    } else {
      console.warn("Notification permission not granted.");
    }
    return null;
  } catch (error) {
    if (error?.name === "AbortError") {
      console.warn(
        "Push subscription was rejected by the browser. Check browser notification permissions and push service connectivity.",
      );
    } else {
      console.warn("Unable to generate an FCM token:", error);
    }
    // alert("⚠️ Error: Push notifications are not available.");
    return null;
  }
};

const openPermissionModal = () => {
  // alert(
  //   "🔔 Notifications are blocked! Follow these steps:\n\n" +
  //     "1️⃣ Click on the 🔒 lock icon in the browser's address bar.\n" +
  //     "2️⃣ Find 'Notifications' and set it to 'Allow'.\n" +
  //     "3️⃣ Reload the page."
  // );
};

export const onMessageListener = () => {
  if (isSafari) {
    console.warn("⚠️ Safari does not support Firebase push notifications.");
    return;
  }

  onMessage(messaging, (payload) => {
    console.log("Message received:", payload);
    const notificationBody = payload.notification?.body;
    if (notificationBody) {
      // alert(`New notification: ${notificationBody}`);
    }
  });
};
